import accountAPI from '@/apis/accounts/accountAPI';
import PackageAPI from '@/apis/package';
import AddOnFeaturesApi from '@/apis/addonfeatures';
import commonFn from '@/commons/commonFunction';
import webSocket from '@/sockets/socket';
export default {
  async getRoles(context) {
    try {
      let res = await accountAPI.getAllRole();
      if (res && res.Data) {
        if (res.Data) {
          context.commit('updateRoles', res.Data);
        }
      }
      return res;
    } catch (ex) {
      commonFn.errorLogging('Lỗi lấy thông tin roles:: ', ex);
    }
  },
  async getNations(context, options = {}) {
    const force = options === true || options?.force === true;
    try {
      if (!force && context.state.Nations?.length) return { Data: context.state.Nations, Success: true };
      let res = await accountAPI.getAllNation();
      if (res?.Data) context.commit('updateNationsGL', res.Data);
      return res;
    } catch (ex) {
      commonFn.errorLogging('Lỗi lấy thông tin nation:: ', ex);
      return { Data: [], Success: false };
    }
  },

  async resetGlobalContext(context) {
    context.commit('resetGlobalContext');
    const results = await Promise.all([
      context.dispatch('getRoles'),
      context.dispatch('getNations'),
      context.dispatch('getAllPartners'),
      context.dispatch('getPackages'),
      context.dispatch('getAddOnFeatures'),
    ]);
    return results;
  },

  async getAllPartners(context, options = {}) {
    const force = options === true || options?.force === true;
    try {
      if (!force && context.state.Partners?.length) return { Data: context.state.Partners, Success: true };
      let res = await accountAPI.getAllPartner();
      if (res?.Data) context.commit('updatePartners', res.Data);
      return res;
    } catch (error) {
      commonFn.errorLogging('Lỗi lấy thông tin partner:: ', error);
      return { Data: [], Success: false };
    }
  },

  async getPackages(context, options = {}) {
    const force = options === true || options?.force === true;
    try {
      if (!force && context.state.Packages?.length) {
        return { Data: context.state.Packages, Success: true };
      }

      const res = await PackageAPI.getListPackage();
      const data = res?.Data?.Data || res?.Data || [];
      context.commit('updatePackages', data);
      return { ...res, Data: data, Success: res?.Success !== false };
    } catch (error) {
      commonFn.errorLogging('Lỗi lấy thông tin packages:: ', error);
      return { Data: [], Success: false };
    }
  },

  /**
   * Danh mục add-on feature (raw, chưa tính giá theo tháng/năm — consumer tự map trên BẢN COPY,
   * không sửa trực tiếp object trong state).
   * Catalog ít đổi → cache ở state, chỉ gọi lại API khi cache rỗng hoặc force = true.
   */
  async getAddOnFeatures(context, options = {}) {
    const force = options === true || options?.force === true;
    try {
      if (!force && context.state.AddOnFeatures?.length) {
        return { Data: context.state.AddOnFeatures, Success: true };
      }

      const res = await AddOnFeaturesApi.getListAddOnFeatures();
      const data = res?.Data?.Data || res?.Data || [];
      context.commit('updateAddOnFeatures', data);
      return { ...res, Data: data, Success: res?.Success !== false };
    } catch (error) {
      commonFn.errorLogging('Lỗi lấy thông tin add-on features:: ', error);
      return { Data: [], Success: false };
    }
  },
};
